class SigninRedirect {
    constructor() {
        jQuery(() => {
            window.location.href = document.querySelector("meta[http-equiv=refresh]").getAttribute("data-url");
        });
    }
}

if (/\/Shared\/Redirect\/?$/i.test(location.pathname)) {
    const signInRedirectWindow = window as any;
    signInRedirectWindow.signInRedirect = new SigninRedirect();
}